export default [
  {
    path: '*',
    name: 'ClientPageNotFoundView',
    component: () => import('@/views/Errors/404.vue'),
    meta: {
    },
  }
]
